import { useTranslation } from 'react-i18next';
import { format, formatDistance } from 'date-fns';
import { dateLocales } from '@/i18n/dateLocales';

export function useDateFormat() {
  const { i18n } = useTranslation();
  const locale = dateLocales[i18n.language] || dateLocales.de;

  return {
    formatDate: (date: Date | string | number) =>
      format(new Date(date), 'PPP', { locale }),

    formatTime: (date: Date | string | number) =>
      format(new Date(date), 'p', { locale }),

    formatDateTime: (date: Date | string | number) =>
      format(new Date(date), 'PPPp', { locale }),

    formatRelative: (date: Date | string | number) =>
      formatDistance(new Date(date), new Date(), { addSuffix: true, locale }),

    formatWeekday: (date: Date | string | number) =>
      format(new Date(date), 'EEEE', { locale }),

    formatShortDate: (date: Date | string | number) =>
      format(new Date(date), 'dd.MM.yyyy', { locale }),

    formatShortTime: (date: Date | string | number) =>
      format(new Date(date), 'HH:mm', { locale }),
  };
}
